
import LayoutInsights from "@/components/layout/insights/LayoutInsights.vue";
import layoutMixin from "@/utils/mixins/layoutMixin";
import UploadLeadService from "@/services/UploadLead";
import S3Service from "@/services/integration/S3Service";
import { Component, Vue, Watch } from "vue-property-decorator";
import { GoogleAnalyticsHelper } from "@/utils/helpers";

const googleAnalytics = new GoogleAnalyticsHelper();

interface UploadStepsInterface {
  step: string;
  text: string;
  info_action: string;
  image: string;
  function: string;
}

type UploadStep = UploadStepsInterface[];

@Component({
  mixins: [
    layoutMixin
  ],

  components: {
    LayoutInsights
  }
})

export default class UploadLeads extends Vue {
  /*
  * Variables
  */
  private uploadSteps: UploadStep = [
    {
      step: 'initial',
      text: 'Clique para fazer o upload',
      info_action: 'necessário formato .csv',
      image: 'icon-cloud-upload.png',
      function: 'selectFile()',
    },
    {
      step: 'uploading',
      text: 'Subindo arquivo',
      info_action: '',
      image: 'icon-cloud-sync.png',
      function: '',
    },
    {
      step: 'cancelled',
      text: 'Upload cancelado',
      info_action: 'Tentar novamente',
      image: 'icon-cloud-off.png',
      function: 'selectFile()',
    },
    {
      step: 'serverError',
      text: 'Ops, aconteceu algum erro.',
      info_action: 'Tente novamente!',
      image: 'icon-cloud-off.png',
      function: 'selectFile()',
    },
    {
      step: 'fileTypeError',
      text: 'Ops, seu arquivo precisa estar em CSV.',
      info_action: 'Verifique e tente novamente',
      image: 'icon-cloud-off.png',
      function: 'selectFile()',
    },
    {
      step: 'success',
      text: 'Upload finalizado',
      info_action: 'Subir outro arquivo',
      image: 'icon-cloud-done.png',
      function: 'selectFile()',
    },
  ]

  private currentStep: UploadStepsInterface = {
    step: 'initial',
    text: 'Clique para fazer o upload',
    info_action: 'necessário formato .csv',
    image: 'icon-cloud-upload.png',
    function: 'selectFile()',
  }

  private leadFilesList: any = [];
  private isLoadingLeadFilesList = false;
  private isCancelPressed = false;
  private csvFile: any = [];
  private uploadPercent: number = 0;
  private progressBarInterval: any = null;

  /*
  * Methods
  */
  private evalFunc(funcName: string) {
    eval(`this.${funcName}`)
  }

  private async changeStep(nextStep: string) {
    let current: any;
    this.uploadSteps.forEach(e => {
      if (e.step === nextStep) current = e
    })
    this.currentStep = current
  }

  private getIconImage() {
    return this.currentStep.image
  }

  private selectFile() {
    const input = document.getElementById('hidden-file-upload')
    if (input) input.click()
  }

  private async uploadFile() {
    this.changeStep('initial')

    if (!this.csvFile || this.csvFile.type !== 'text/csv') {
      this.changeStep('fileTypeError')

      return
    }

    this.changeStep('uploading')

    const requestOptions = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }

    const env = process.env.NODE_ENV === 'development' ? '/dev' : '';

    try {
      const s3Service = new S3Service()
      const UploadLead = new UploadLeadService()

      const csvPath = env ? env : `csv/${this.$auth.user().id_platform}`
      const csvBucket = 'sftp-weclever'
      const ext = '.csv'
      const csvFileName = `${this.$auth.user().id_platform}_${this.$moment().format('YYYY-MM-DD-HHmmss')}_${this.csvFile.name.replace('.csv', '')}`

      this.initProgressBar()

      const csvData = await s3Service.getUrlUpload({
        path: csvPath,
        bucket: csvBucket,
        extension: ext,
        fileName: csvFileName
      });

      const csvFileUploadRes: any = await this.$http.put(csvData.url, this.csvFile, requestOptions);

      if (csvFileUploadRes.status === 200){
        const body = {
          archives: csvFileName + ext,
          path: csvPath
        }

        await UploadLead.uploadLead(body).catch((err) => {
          console.log(err);
          this.$store.commit("navBarAlert/DANGER_ALERT", err)
        });

        this.changeStep('success')
        this.refreshFilesList()

        googleAnalytics.event('upload_arquivo_enviado')
      } else {
        this.changeStep('serverError')
      }

    } catch (error) {
      this.$store.commit("navBarAlert/DANGER_ALERT", "Erro ao salvar dados. Por favor, recarregue a página e tente novamente.")
    }

    this.csvFile = null
    this.uploadPercent = 0

    clearInterval(this.progressBarInterval)
  }

  private initProgressBar() {
    let progressCurrent = 0
    let step = 0.5

    this.progressBarInterval = setInterval(() => {
      progressCurrent += step

      const progress = Math.round(Math.atan(progressCurrent) / (Math.PI / 2) * 100 * 1000) / 1000

      this.uploadPercent = Math.floor(progress)

      if (progress >= 100) {
        clearInterval(this.progressBarInterval)
      } else if (progress >= 70) {
        step = 0.1
      }
    }, 100);
  }

  private cancelUploadFile() {
    this.isCancelPressed = true
    this.csvFile = null
    this.uploadPercent = 0

    clearInterval(this.progressBarInterval)

    this.changeStep('cancelled')
  }

  private async refreshFilesList() {
    const UploadLead = new UploadLeadService()
    this.isLoadingLeadFilesList = true
    this.leadFilesList = await UploadLead.listUploadedLeads()
    this.isLoadingLeadFilesList = false
  }

  private async mounted() {
    this.refreshFilesList();
  }

  @Watch('csvFile')
  onCsvFileChange() {
    if (this.csvFile) {
      this.uploadFile()
    }
  }
}
